import React, { useState } from "react";
import { useLocation, useNavigate, Navigate } from "react-router-dom";
import { base_url } from "../../Global";
import logo from "../../assets/legacy grey.png";
import { Box, Typography, InputBase, ButtonBase, Link } from "@mui/material";

const AccountReset = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const email = location.state?.email;

  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  // Protect the route: Redirect to forgot-password if there is no email in state
  if (!email) {
    return <Navigate to="/forgot-password" replace />;
  }

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (newPassword !== confirmPassword) {
      alert("Passwords do not match!");
      return;
    }

    if (newPassword.length < 6) {
      alert("Password must be at least 6 characters long.");
      return;
    }

    try {
      // Note: Ensure your backend has an endpoint to catch this!
      // e.g., router.post('/admin-reset-password', adminResetPasswordFunc)
      const response = await fetch(`${base_url}/auth/reset-password`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email: email, newPassword: newPassword }),
      });

      if (response.ok) {
        const data = await response.json();
        alert(data.message || "Password reset successfully!");
        navigate("/login");
      } else {
        const errorData = await response.json();
        alert(
          errorData.message || "Something went wrong updating the password.",
        );
      }
    } catch (error) {
      console.error(error);
      alert("Network error, please try again.");
    }
  };

  return (
    <Box className="w-full relative px-[20px] pt-[50px] pb-[50px] h-[100vh] text-left text-[1.125rem] text-white font-gilroy bg-gray-400 shadow-[0px_4px_74px_rgba(0,_0,_0,_0.25)] overflow-hidden flex flex-col items-center justify-start box-border gap-[1rem] tracking-[normal] mq700:gap-[1rem] mq950:flex-wrap mq975:gap-[1rem]">
      <Box
        component="form"
        onSubmit={handleSubmit}
        className="m-0 rounded-3xl bg-gray-200 flex flex-col items-center justify-start mt-10 pt-[1.75rem] pb-[2.13rem] pr-[2.94rem] pl-[3rem] box-border gap-[1rem] max-w-full z-[2] mq700:pl-[1.5rem] mq700:pr-[1.44rem] mq700:box-border mq950:pt-[1.25rem] mq950:pb-[1.38rem] mq950:box-border"
      >
        <Box className="self-stretch flex flex-col items-center justify-start gap-[0.5rem]">
          <Box
            component="img"
            className="w-[150px] h-[36px] relative z-[3]"
            loading="eager"
            alt="Logo"
            src={logo}
          />

          <Typography
            component="h1"
            className="m-0 flex-1 relative text-inherit leading-[2.375rem] capitalize font-bold font-inherit flex items-center z-[1] mq925:text-[1.875rem] mq925:leading-[1.875rem] mq450:text-[1.438rem] mq450:leading-[1.438rem]"
          >
            Reset Password
          </Typography>

          {/* New Password Input */}
          <Box className="self-stretch flex flex-col items-start justify-start pt-[0.25rem] px-[0rem] pb-[0.5rem] relative gap-[0.25rem] z-[3]">
            <Box className="h-[19px] relative leading-[18px] capitalize flex items-center shrink-0 z-[1]">
              new password
            </Box>
            <InputBase
              type="password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              required
              className="w-full bg-gray-500 self-stretch h-[48px] rounded-3xs flex flex-row items-start justify-start py-[13px] px-[18px] box-border font-gilroy font-light text-[1.125rem] text-gray-400 min-w-[300px] z-[1]"
              placeholder="Enter new password"
            />
          </Box>

          {/* Confirm Password Input */}
          <Box className="self-stretch flex flex-col items-start justify-start pt-[0.25rem] px-[0rem] pb-[0.5rem] relative gap-[0.25rem] z-[3]">
            <Box className="h-[19px] relative leading-[18px] capitalize flex items-center shrink-0 z-[1]">
              confirm password
            </Box>
            <InputBase
              type="password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
              className="w-full bg-gray-500 self-stretch h-[48px] rounded-3xs flex flex-row items-start justify-start py-[13px] px-[18px] box-border font-gilroy font-light text-[1.125rem] text-gray-400 min-w-[300px] z-[1]"
              placeholder="Confirm new password"
            />
          </Box>
        </Box>

        <Box className="self-stretch flex-1 flex flex-col items-start justify-start max-w-full">
          <ButtonBase
            type="submit"
            className="no-underline cursor-pointer bg-white self-stretch my-4 rounded-lg flex flex-row items-center justify-center box-border max-w-full whitespace-nowrap z-[3] hover:bg-chocolate"
          >
            <Box className="relative text-[20px] leading-[40px] text-gray-200 capitalize font-semibold font-poppins text-left z-[4]">
              Update Password
            </Box>
          </ButtonBase>
          <Box className="self-stretch flex flex-col items-center justify-start max-w-full z-[3]">
            <Link
              component="button"
              type="button"
              onClick={() => navigate("/login")}
              className="text-white text-[1rem] font-gilroy underline cursor-pointer"
            >
              Cancel and return to Login
            </Link>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default AccountReset;
